module.exports = __webpack_public_path__ + "static/media/world-map.583926b5.png";